<div class="platform-settings">
  <aside class="platform-settings-sidebar">
    <div class="platform-settings-sidebar-header">
      <h2>Impostazioni piattaforma</h2>
      <p>Abbonamenti, feature e record DNS</p>
    </div>
    <nav class="platform-settings-nav" aria-label="Sezioni impostazioni piattaforma">
      <button type="button" [class.is-active]="activeTab === 'subscriptions'" (click)="setTab('subscriptions')">
        <i class="bi bi-credit-card" aria-hidden="true"></i>
        Abbonamenti
      </button>
      <button type="button" [class.is-active]="activeTab === 'features'" (click)="setTab('features')">
        <i class="bi bi-puzzle" aria-hidden="true"></i>
        Feature
      </button>
      <button type="button" [class.is-active]="activeTab === 'domains'" (click)="setTab('domains')">
        <i class="bi bi-globe" aria-hidden="true"></i>
        Domini
      </button>
    </nav>
  </aside>

  <div class="platform-settings-content">
    <div class="platform-settings-content-inner">
    <header class="platform-settings-content-header" *ngIf="activeTab !== 'domains'">
      <h1 class="text-lg font-semibold">{{ sectionTitle }}</h1>
      <p class="text-sm">{{ sectionDescription }}</p>
    </header>

<!-- Tab: Features CRUD -->
<ng-container *ngIf="activeTab === 'features'">
  <div class="subscription-card">
    <div class="subscription-card-inner">
      <h4 class="mb-0 text-sm font-semibold text-slate-900">Nuova feature</h4>
      <form #newFeatureForm="ngForm" class="grid grid-cols-1 gap-3 md:grid-cols-[1fr_1fr_auto] md:items-end" (ngSubmit)="saveNewFeature()">
        <div>
          <label for="new-code" class="form-label required">Codice (id)</label>
          <input type="text" class="form-control text-sm" id="new-code"
                 [(ngModel)]="newFeature.code" name="newCode" required placeholder="Es. Dashboard" />
        </div>
        <div>
          <label for="new-name" class="form-label required">Nome</label>
          <input type="text" class="form-control text-sm" id="new-name"
                 [(ngModel)]="newFeature.name" name="newName" required placeholder="Es. Dashboard" />
        </div>
        <button type="submit" class="btn welldone-btn-light text-sm" [disabled]="!newFeature.code.trim() || !newFeature.name.trim()">
          Aggiungi
        </button>
      </form>
    </div>
  </div>

  <div *ngIf="loading" class="py-8 text-center text-sm text-slate-500">Caricamento...</div>
  <div *ngIf="!loading && features.length === 0" class="rounded-2xl border border-dashed border-slate-200 bg-white px-4 py-8 text-center text-sm text-slate-500">
    Nessuna feature. Aggiungine una sopra.
  </div>
  <div *ngIf="!loading && features.length > 0" class="subscription-card feature-list-card">
    <div *ngFor="let f of features" class="feature-row">
      <div class="feature-icon" aria-hidden="true">
        <i class="bi bi-puzzle"></i>
      </div>
      <div class="min-w-0 flex-1">
        <ng-container *ngIf="editFeature?.code !== f.code">
          <div class="text-sm font-semibold text-slate-900">{{ f.name }}</div>
          <div class="text-xs text-slate-500">{{ f.code }}</div>
        </ng-container>
        <div *ngIf="editFeature && editFeature.code === f.code" class="flex max-w-md flex-col gap-2">
          <input type="text" class="form-control text-sm" [(ngModel)]="editFeature.name" placeholder="Nome" />
          <input type="text" class="form-control text-sm" [(ngModel)]="editFeature.code" placeholder="Codice" />
        </div>
      </div>
      <div class="settings-actions">
        <ng-container *ngIf="editFeature?.code !== f.code">
          <button type="button" class="btn welldone-btn-gray" (click)="startEditFeature(f)" title="Modifica" aria-label="Modifica feature">
            <i class="bi bi-pencil" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn welldone-btn-danger" (click)="deleteFeature(f)" title="Elimina" aria-label="Elimina feature">
            <i class="bi bi-trash" aria-hidden="true"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="editFeature?.code === f.code">
          <button type="button" class="btn welldone-btn-gray" (click)="saveEditFeature()" title="Salva" aria-label="Salva feature">
            <i class="bi bi-check2" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn welldone-btn-gray" (click)="cancelEditFeature()" title="Annulla" aria-label="Annulla modifica">
            <i class="bi bi-x-lg" aria-hidden="true"></i>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!-- Tab: Subscriptions (price, features, visible toggle, copy link, edit features) -->
<ng-container *ngIf="activeTab === 'subscriptions'">
  <!-- Add subscription card: always visible so it doesn't flash when switching loading states -->
  <div class="subscription-card add-subscription-card" [class.add-subscription-empty]="!loadingSubscriptions && subscriptionPlans.length === 0">
    <div class="subscription-card-inner">
      <h4 class="mb-0 text-sm font-semibold text-slate-900">
        {{ (!loadingSubscriptions && subscriptionPlans.length === 0) ? 'Crea il tuo primo abbonamento' : 'Aggiungi abbonamento' }}
      </h4>
      <form #newSubscriptionForm="ngForm" (ngSubmit)="createSubscription()" class="add-subscription-form flex flex-col gap-3">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
          <div class="md:col-span-2">
            <label for="new-sub-name" class="form-label required">Nome abbonamento</label>
            <input type="text" class="form-control w-full text-sm" id="new-sub-name"
                   [(ngModel)]="newSubscription.name" name="newSubName" required placeholder="Es. Piano Base" />
          </div>
          <div>
            <label for="new-sub-price" class="form-label required">Prezzo mensile (€)</label>
            <input type="text" class="form-control w-full text-sm" id="new-sub-price"
                   [(ngModel)]="newSubscription.price" name="newSubPrice" required placeholder="9.99"
                   (ngModelChange)="onNewSubscriptionMonthlyPriceChange($event)" />
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <label class="form-label mb-0">Frequenza di fatturazione</label>
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
            <button type="button"
                    class="inline-flex h-9 w-full items-center justify-center rounded-lg border px-3 text-sm font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    [ngClass]="newSubscriptionCycleMonths === 6
                      ? 'border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:border-emerald-400 focus-visible:outline-emerald-600'
                      : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-300 focus-visible:outline-[var(--primary-color,#00ae9e)]'"
                    (click)="onNewSubscriptionCycleMonthsChange(6)">
              Ogni 6 mesi
            </button>
            <button type="button"
                    class="inline-flex h-9 w-full items-center justify-center rounded-lg border px-3 text-sm font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    [ngClass]="newSubscriptionCycleMonths === 12
                      ? 'border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:border-emerald-400 focus-visible:outline-emerald-600'
                      : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-300 focus-visible:outline-[var(--primary-color,#00ae9e)]'"
                    (click)="onNewSubscriptionCycleMonthsChange(12)">
              Ogni 12 mesi
            </button>
            <button type="button"
                    class="inline-flex h-9 w-full items-center justify-center rounded-lg border px-3 text-sm font-medium transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    [ngClass]="newSubscriptionCycleMonths === 24
                      ? 'border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:border-emerald-400 focus-visible:outline-emerald-600'
                      : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50 hover:border-slate-300 focus-visible:outline-[var(--primary-color,#00ae9e)]'"
                    (click)="onNewSubscriptionCycleMonthsChange(24)">
              Ogni 24 mesi
            </button>
          </div>
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-[1fr_auto] sm:items-end">
            <div>
              <label for="new-sub-annual" class="form-label mb-1">Prezzo totale ({{ getSelectedCycleLabel() }}) (€)</label>
              <input type="text" class="form-control w-full text-sm" id="new-sub-annual"
                     [ngModel]="newSubscription.annualPrice" name="newSubAnnual"
                     (ngModelChange)="onNewSubscriptionAnnualPriceChange($event)" />
            </div>
            <button *ngIf="isAnnualPriceManuallyEdited"
                    type="button"
                    class="inline-flex h-9 items-center justify-center rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:border-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--primary-color,#00ae9e)]"
                    (click)="useAutoCalculatedAnnualPrice()">
              Usa calcolo automatico
            </button>
          </div>
        </div>

        <div class="subscription-features">
          <div class="mb-2 flex items-center justify-between gap-2">
            <div class="subscription-features-title mb-0">Funzionalità incluse</div>
            <span class="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600">
              {{ newSubscriptionFeatures.length }}
            </span>
          </div>

          <ul class="subscription-features-list" *ngIf="newSubscriptionFeatures.length; else noNewSubFeatures">
            <li *ngFor="let feat of newSubscriptionFeatures" class="feature-edit">
              <span>{{ feat.name }}</span>
              <button type="button"
                      class="btn-remove-feature"
                      (click)="removeFeatureFromNewSubscription(feat.code)"
                      title="Rimuovi funzionalità"
                      aria-label="Rimuovi funzionalità">
                ×
              </button>
            </li>
          </ul>

          <ng-template #noNewSubFeatures>
            <p class="mb-2 text-sm text-gray-500">Nessuna funzionalità selezionata.</p>
          </ng-template>

          <div class="grid grid-cols-1 gap-2 sm:grid-cols-[1fr_auto] sm:items-end mt-2">
            <div>
              <select id="new-sub-feature"
                      class="form-control form-select w-full"
                      [(ngModel)]="addFeatureToNewSubscriptionCode"
                      name="newSubFeature">
                <option value="">Seleziona feature</option>
                <option *ngFor="let f of getAvailableFeaturesForNewSubscription()" [value]="f.code">
                  {{ f.name }} ({{ f.code }})
                </option>
              </select>
            </div>
            <button type="button"
                    class="inline-flex h-9 items-center justify-center rounded-lg border border-slate-200 bg-white px-4 text-sm font-medium text-slate-700 transition-colors duration-150 hover:bg-slate-50 hover:border-slate-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--primary-color,#00ae9e)] disabled:cursor-not-allowed disabled:opacity-50"
                    (click)="addFeatureToNewSubscription()"
                    [disabled]="!addFeatureToNewSubscriptionCode">
              Aggiungi
            </button>
          </div>
        </div>

        <div class="flex flex-wrap items-center gap-3">
          <label for="custom-sub-toggle" class="mb-0 text-sm font-medium text-slate-800">Abbonamento personalizzato</label>
          <div class="form-check form-switch m-0">
            <input class="form-check-input" type="checkbox" role="switch" id="custom-sub-toggle"
                   [(ngModel)]="isCustomSubscription" name="customSubToggle">
          </div>
          <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                [ngClass]="isCustomSubscription ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-500'">
            {{ isCustomSubscription ? 'Attivo' : 'Disattivo' }}
          </span>
        </div>

        <div *ngIf="isCustomSubscription" class="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div>
            <label for="new-sub-fee" class="form-label mb-1">Commissione (%)</label>
            <input type="text" class="form-control w-full" id="new-sub-fee"
                   [(ngModel)]="newSubscription.customFeeRate" name="newSubFee" placeholder="Es. 5" />
          </div>
          <div>
            <label for="new-sub-months" class="form-label mb-1">Durata (mesi)</label>
            <input type="text" class="form-control w-full" id="new-sub-months"
                   [(ngModel)]="newSubscription.monthCount" name="newSubMonths" placeholder="Es. 12" />
            <p class="mt-1 mb-0 text-xs text-gray-500">Lascia vuoto per durata infinita</p>
          </div>
        </div>

        <div>
          <button type="submit" class="btn welldone-btn-light w-full text-sm font-semibold" [disabled]="!newSubscription.name.trim() || !newSubscription.price.trim()">
            {{ (!loadingSubscriptions && subscriptionPlans.length === 0) ? 'Crea abbonamento' : 'Aggiungi' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="plan-toolbar">
    <input
      type="search"
      class="form-control text-sm"
      [(ngModel)]="planSearch"
      name="planSearch"
      placeholder="Cerca abbonamento"
    />
    <div class="plan-toolbar-pills" role="group" aria-label="Filtro visibilità">
      <button type="button" [class.is-active]="planVisibility === 'all'" (click)="planVisibility = 'all'">Tutti</button>
      <button type="button" [class.is-active]="planVisibility === 'visible'" (click)="planVisibility = 'visible'">Visibili</button>
      <button type="button" [class.is-active]="planVisibility === 'hidden'" (click)="planVisibility = 'hidden'">Nascosti</button>
    </div>
    <select class="form-control form-select text-sm" [(ngModel)]="planSort" name="planSort">
      <option value="date-newest">Più recenti</option>
      <option value="date-oldest">Più vecchi</option>
      <option value="price-asc">Prezzo crescente</option>
      <option value="price-desc">Prezzo decrescente</option>
      <option value="name">Nome A–Z</option>
    </select>
  </div>

  <!-- Skeleton loading: only for the list below the add card -->
  <div *ngIf="loadingSubscriptions" class="subscriptions-skeleton">
    <div class="subscription-card subscription-card-skeleton">
      <div class="subscription-card-inner">
        <div class="subscription-header">
          <div>
            <div class="skeleton skeleton-title" style="width: 220px;"></div>
            <div class="skeleton skeleton-badge" style="width: 80px;"></div>
          </div>
          <div class="d-flex align-items-center gap-3">
            <div class="skeleton skeleton-switch"></div>
            <div class="skeleton skeleton-btn"></div>
            <div class="skeleton skeleton-btn"></div>
          </div>
        </div>
        <div class="subscription-price">
          <div class="skeleton skeleton-amount" style="width: 100px;"></div>
          <div class="skeleton skeleton-period" style="width: 140px; margin-top: 0.5rem;"></div>
        </div>
        <div class="subscription-features">
          <div class="skeleton skeleton-features-title" style="width: 140px;"></div>
          <div class="skeleton-features-list">
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="subscription-card subscription-card-skeleton">
      <div class="subscription-card-inner">
        <div class="subscription-header">
          <div>
            <div class="skeleton skeleton-title" style="width: 180px;"></div>
            <div class="skeleton skeleton-badge" style="width: 70px;"></div>
          </div>
          <div class="d-flex align-items-center gap-3">
            <div class="skeleton skeleton-switch"></div>
            <div class="skeleton skeleton-btn"></div>
            <div class="skeleton skeleton-btn"></div>
          </div>
        </div>
        <div class="subscription-price">
          <div class="skeleton skeleton-amount" style="width: 90px;"></div>
        </div>
        <div class="subscription-features">
          <div class="skeleton skeleton-features-title" style="width: 130px;"></div>
          <div class="skeleton-features-list">
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="subscription-card subscription-card-skeleton">
      <div class="subscription-card-inner">
        <div class="subscription-header">
          <div>
            <div class="skeleton skeleton-title" style="width: 200px;"></div>
            <div class="skeleton skeleton-badge" style="width: 75px;"></div>
          </div>
          <div class="d-flex align-items-center gap-3">
            <div class="skeleton skeleton-switch"></div>
            <div class="skeleton skeleton-btn"></div>
            <div class="skeleton skeleton-btn"></div>
          </div>
        </div>
        <div class="subscription-price">
          <div class="skeleton skeleton-amount" style="width: 95px;"></div>
          <div class="skeleton skeleton-period" style="width: 160px; margin-top: 0.5rem;"></div>
        </div>
        <div class="subscription-features">
          <div class="skeleton skeleton-features-title" style="width: 135px;"></div>
          <div class="skeleton-features-list">
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
            <span class="skeleton skeleton-pill"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- List of existing subscriptions (hidden while loading) -->
  <ng-container *ngIf="!loadingSubscriptions">
    <div *ngIf="filteredSubscriptionPlans.length === 0" class="rounded-2xl border border-dashed border-slate-200 bg-white px-4 py-8 text-center text-sm text-slate-500">
      {{ subscriptionPlans.length === 0 ? 'Nessun abbonamento. Creane uno sopra.' : 'Nessun abbonamento corrisponde ai filtri.' }}
    </div>
    <div *ngFor="let plan of filteredSubscriptionPlans" class="subscription-card">
      <div class="subscription-card-inner">
        <div class="subscription-header">
          <div class="flex min-w-0 items-start gap-3">
            <div class="feature-icon" aria-hidden="true">
              <i class="bi bi-credit-card"></i>
            </div>
            <div class="min-w-0">
              <h4 class="mb-0 text-sm font-semibold text-slate-900">{{ plan.name }}</h4>
              <div class="mt-1 flex flex-wrap items-center gap-2">
                <span class="subscription-status" [class.active]="plan.visible">
                  {{ plan.visible ? 'Visibile' : 'Nascosto' }}
                </span>
                <span class="text-sm font-semibold text-slate-900" *ngIf="plan.price">
                  {{ plan.price }}€<span class="text-xs font-medium text-slate-500">/mese</span>
                </span>
              </div>
              <div class="mt-0.5 text-xs text-slate-500" *ngIf="plan.annualPrice">
                {{ getAnnualPricePerMonth(plan.annualPrice, plan.recurrency) }}€/mese fatturato ogni {{ plan.recurrency || 12 }} mesi
              </div>
            </div>
          </div>
          <div class="settings-actions">
              <button type="button"
                      class="btn welldone-btn-gray"
                      [class.is-visible]="plan.visible"
                      (click)="togglePlanVisible(plan)"
                      title="Visibilità nel listino: mostra o nascondi il piano per le nuove registrazioni"
                      aria-label="Visibilità nel listino: mostra o nascondi il piano per le nuove registrazioni">
                <i class="bi" [ngClass]="plan.visible ? 'bi-eye-fill' : 'bi-eye-slash-fill'" aria-hidden="true"></i>
              </button>
              <button type="button"
                      class="btn welldone-btn-gray"
                      (click)="copyCustomSubscriptionLink(plan)"
                      title="Copia link di registrazione con questo abbonamento"
                      aria-label="Copia link di registrazione con questo abbonamento">
                <i class="bi bi-link-45deg" aria-hidden="true"></i>
              </button>
              <ng-container *ngIf="editPlanId !== plan.id">
                <button type="button"
                        class="btn welldone-btn-gray"
                        (click)="startEditPlan(plan)"
                        title="Modifica le funzionalità incluse"
                        aria-label="Modifica le funzionalità incluse">
                  <i class="bi bi-pencil" aria-hidden="true"></i>
                </button>
                <button type="button"
                        class="btn welldone-btn-danger"
                        (click)="deleteSubscription(plan)"
                        title="Elimina questo abbonamento"
                        aria-label="Elimina questo abbonamento">
                  <i class="bi bi-trash" aria-hidden="true"></i>
                </button>
              </ng-container>
              <button *ngIf="editPlanId === plan.id" type="button"
                      class="btn welldone-btn-gray"
                      (click)="cancelEditPlan()"
                      title="Annulla modifica"
                      aria-label="Annulla modifica">
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
          </div>
        </div>

        <div class="flex flex-wrap gap-2" *ngIf="plan.recurrency !== null || plan.customFeeRate !== null || plan.monthCount !== null">
          <span *ngIf="plan.recurrency !== null" class="badge badge-unknown">
            Ogni {{ plan.recurrency }} mesi
          </span>
          <span *ngIf="plan.customFeeRate !== null" class="badge badge-unknown">
            Commissione {{ plan.customFeeRate * 100 }}%
          </span>
          <span *ngIf="plan.monthCount !== null" class="badge badge-unknown">
            Durata {{ plan.monthCount }} mesi
          </span>
        </div>

        <div class="subscription-features">
          <div class="subscription-features-title">Funzionalità incluse</div>
          <ul class="subscription-features-list" *ngIf="plan.features?.length">
            <li *ngFor="let feature of plan.features" [class.feature-edit]="editPlanId === plan.id">
              {{ feature.name }}
              <button *ngIf="editPlanId === plan.id" type="button" class="btn-remove-feature" (click)="removeFeatureFromPlan(plan, feature.code)">×</button>
            </li>
          </ul>
          <p *ngIf="!plan.features?.length && editPlanId !== plan.id" class="mb-0 text-xs text-slate-500">Nessuna feature associata.</p>
          <div *ngIf="editPlanId === plan.id" class="mt-2 flex flex-wrap items-center gap-2">
            <select class="form-control form-select text-sm" [(ngModel)]="addFeatureToPlanCode" style="max-width: 220px;">
              <option value="">Seleziona feature</option>
              <option *ngFor="let feat of getAvailableFeaturesForPlan(plan)" [value]="feat.code">
                {{ feat.name }} ({{ feat.code }})
              </option>
            </select>
            <button type="button" class="btn welldone-btn-light text-sm" (click)="addFeatureToPlan(plan)" [disabled]="!addFeatureToPlanCode">
              Aggiungi
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="activeTab === 'domains'">
  <app-admin-domains [embedded]="true">
    <h1>{{ sectionTitle }}</h1>
    <p>{{ sectionDescription }}</p>
  </app-admin-domains>
</ng-container>
    </div>
  </div>
</div>
